module.exports = __webpack_public_path__ + "assets/ChildAccidentTemplate-89e532390039b800912fd4be1dd9a1fc.xlsx";